import React from 'react';
import { Link } from 'react-router-dom';

const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-white text-slate-800">
    <header className="border-b border-slate-200 py-4 px-6">
      <div className="max-w-3xl mx-auto flex items-center justify-between">
        <Link to="/" className="text-xl font-bold tracking-tight">
          off<span style={{ color: '#f59e0b' }}>f</span>er
        </Link>
        <nav className="text-sm text-slate-500 flex gap-4">
          <Link to="/impressum" className="hover:text-slate-900">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-slate-900">Datenschutz</Link>
          <Link to="/agb" className="hover:text-slate-900">AGB</Link>
        </nav>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-8 text-slate-900">{title}</h1>
      <div className="prose prose-slate max-w-none [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:font-semibold [&_h3]:mt-6 [&_p]:leading-relaxed [&_p]:mb-3">
        {children}
      </div>
      <footer className="mt-16 pt-6 border-t border-slate-200 text-xs text-slate-400">
        Stand: 12.06.2026 · offfer.de
      </footer>
    </main>
  </div>
);

export default LegalLayout;
